import moment from "moment";
import { CollectionAction } from "./action";
import { CollectionState, collectionState } from "./state";

export function CollectionReducer(
    state: CollectionState = collectionState,
    action: CollectionAction
): CollectionState {
    switch (action.type) {
        case "@@collectionState/initCollectionDetailAction":
            return {
                ...state,
                collectionDetail: action.collectionDetail,
                signature_image: action.signature_image,
                signature_image_thumb: action.signature_image_thumb,
                collectionPhotoList: action.collectionPhotoList,
            };

        case "@@collectionState/initCollectionAttendanceAction":
            return {
                ...state,
                attendanceCollectionInfo: action.attendanceCollectionInfo,
            };

        case "@@collectionState/initUnloadDataAction":
            return {
                ...state,
                unloadCollectionInfo: action.unloadCollectionInfo,
            };
        case "@@collectionState/initUnloadImageAction":
            return {
                ...state,
                unloadImageList: action.unloadImageList,
            };

        case "@@collectionState/changeBinInfoAction":
            return {
                ...state,
                binInfo:action.binInfo!
            };

        case "@@collectionState/initSelectedEditattendanceAction":
            return {
                ...state,
                selectedEditattendanceCollection: {
                    ...state.selectedEditattendanceCollection,
                    attendance_date: moment.utc(
                        action.attendanceCollectionInfo.attendance_date
                    ),
                    collection_date: moment.utc(
                        action.attendanceCollectionInfo.collection_date
                    ),
                    value: action.attendanceCollectionInfo.bin_id,
                    collection_id:
                        action.attendanceCollectionInfo.collection_id,
                    route_id:action.attendanceCollectionInfo.route_id
                },
            };

        case "@@collectionState/ChangeAttendaceDateTimeAction":
            return {
                ...state,
                selectedEditattendanceCollection: {
                    ...state.selectedEditattendanceCollection,
                    attendance_date: moment.utc(action.date),
                },
            };

        case "@@collectionState/handleCollectionDateAction":
            return {
                ...state,
                selectedEditattendanceCollection: {
                    ...state.selectedEditattendanceCollection,
                    collection_date: moment.utc(action.date),
                },
            };

        case '@@collectionState/initSelectedEditionCollectionDetailAction':
            return {
                ...state,
                selectedEditCollectionDetail:action.collectionDetail
            }

        case '@@collectionState/ChangeRecyclabeAction':
            return {
                ...state,
                selectedEditCollectionDetail:{
                    ...state.selectedEditCollectionDetail!,
                    recyclable_id:action.targetReyclableInfo.recyclable_id.toString(),
                    recyclable:action.targetReyclableInfo.recyclable
                }
            }

        case '@@collectionState/ChangeCollectionWeightAction':
            return {
                ...state,
                selectedEditCollectionDetail:{
                    ...state.selectedEditCollectionDetail!,
                    collection_weight:parseFloat(action.collection_weight),
                    net_weight:parseFloat((parseFloat(action.collection_weight)-action.targetContainerInfo.weight).toFixed(1))
                } 
            }

        case '@@collectionState/ChangeContainerAction':
            
            return {
                ...state,
                selectedEditCollectionDetail:{
                    ...state.selectedEditCollectionDetail!,
                    container_id:action.targetContainerInfo.container_id.toString(),
                    net_weight:  parseFloat((parseFloat(action.collection_weight) - action.targetContainerInfo.weight).toFixed(1))
                }
            }
        
        case '@@collectionState/ChangeCollectionDetailAction':
            return {
                ...state,
                collectionDetail:action.collectionDetail
            }

        case '@@collectionState/InitSelectedUnloadCollectionAction':
            return{
                ...state,
                selectedUnloadCollectionInfo:action.unloadCollectionInfo
            }

        case '@@collectionState/ChangeUnloadCollectionDepotAction':
            return {
                ...state,
                selectedUnloadCollectionInfo:{
                    ...state.selectedUnloadCollectionInfo!,
                    depot_id:parseInt(action.depot_id)

                }
            }

        case '@@collectionState/ChangeUnloadCollectionMetalAction':
            return {
                ...state,
                selectedUnloadCollectionInfo:{
                    ...state.selectedUnloadCollectionInfo!,
                    metal_weight:parseFloat(action.metal_weight),
                    total_weight:parseFloat(action.total_weight),
                    total_kurbside_weight:parseFloat(action.total_weight),
                }
            }

        case '@@collectionState/ChangeUnloadCollectionPaperAction':
            return {
                ...state,
                selectedUnloadCollectionInfo:{
                    ...state.selectedUnloadCollectionInfo!,
                    paper_weight:parseFloat(action.paper_weight),
                    total_weight:parseFloat(action.total_weight),
                    total_kurbside_weight:parseFloat(action.total_weight),
                }
            }
        case '@@collectionState/ChangeUnloadCollectionPlasticAction':
            return {
                ...state,
                selectedUnloadCollectionInfo:{
                    ...state.selectedUnloadCollectionInfo!,
                    plastic_weight:parseFloat(action.plastic_weight),
                    total_weight:parseFloat(action.total_weight),
                    total_kurbside_weight:parseFloat(action.total_weight)
                }
            }


        case '@@collectionState/ChangeUnloadCollectionTotalWeightAction':
            return {
                ...state,
                selectedUnloadCollectionInfo:{
                    ...state.selectedUnloadCollectionInfo!,
                    total_school_weight:parseFloat(action.total_weight),
                    total_weight:parseFloat(action.total_weight)
                }
            }
        case '@@collectionState/ChangeCollectionPhotoListAction':
            return  {
                ...state,
                collectionPhotoList: action.collectionPhotoList,
            }

        case '@@collectionState/ChangeSignatureImageAction':
            return {
                ...state,
                signature_image:action.signature_image,
                signature_image_thumb:action.signature_image
                
            }

        default:
            return state;
    }
}
